import { inject, Injectable } from '@angular/core';
import { IkpEnvironmentService } from '../environment/ikp-environment.service';
import { track } from '@mwe/utils';
import { FaqCategory, FaqItem } from '../../model/faq.model';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  private environmentService = inject(IkpEnvironmentService);

  private readonly ROOT_URL_NAME = 'frontpage';

  trackVirtualPageView(url: string) {
    const contents = {
      title: this.getTitle(url),
      url: url,
    };
    const event = 'virtualPageView';
    this.logTrackingEvent(event, contents);
    track(event, contents);
  }

  trackFaq(faqItem: FaqItem, faqCategory: FaqCategory) {
    const contents = {
      'faq-category': faqCategory.name,
      'faq-id': faqItem.id,
      'faq-name': faqItem.question,
      options: 'faq click',
    };
    const event = 'faq-interaction';
    this.logTrackingEvent(event, contents);
    track(event, contents);
  }

  getTitle(url: string) {
    const parts = url.split('/');
    if (this.hasIdParameter(parts)) {
      return parts[parts.length - 2] + '-details';
    }
    let title = parts[parts.length - 1];
    title = title.replace('=', '-');
    if (title.indexOf('#') > -1) {
      title = this.handleHash(title);
    }
    title = title.replace('#', '');
    return title == '' ? this.ROOT_URL_NAME : title;
  }

  hasIdParameter(parts: string[]) {
    if (parts.length >= 3 && parts[parts.length - 1].length == 36) {
      return true;
    }
  }

  handleHash(title: string) {
    const hash = title.split('#')[1];
    if (hash.startsWith('ey')) {
      return title.split('#')[0];
    }
    return title.replace('#', '');
  }

  logTrackingEvent(event: string, contents: object) {
    if (this.environmentService.isPiwikProTrackingDebugEnabled()) {
      console.log('Tracking event: ', JSON.stringify({ ...contents, event }));
    }
  }
}
